// 引入 axios
import axios from 'axios';
import router from '../router';

// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VITE_APP_API_URL, 
  // baseURL: "http://localhost:8088", // 使用Vue CLI的环境变量语法
  timeout: 5000, // 请求超时时间
});

// request 拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前添加token认证
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    // 添加客户端类型标识
    config.headers['X-Client-Type'] = 'web';
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// respone 拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    return response.data;
  },
  error => {
    if (error.response && error.response.status === 401) {
      // 清除用户信息
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      // 重定向到登录页面
      router.push('/login');
    }
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default service;